import { Typography, Box, Button, Alert, Grid2 as Grid, Chip } from '@mui/material';
import { FC } from 'react';
import { Add, Delete } from '@mui/icons-material';

import { JobseekerCreateDto } from '@libs/dto';
import { useForm } from '@carcareers/contexts';
import { TextInput, DateInput } from '@carcareers/components';

export const EducationStep: FC = () => {
  const { data, setData } = useForm<JobseekerCreateDto>();
  const educations = data?.educations || [];

  const addEducation = () => {
    const newEducation = {
      school: '',
      level: '',
      areaOfStudy: '',
      startDate: '',
      endDate: '',
      current: false,
    };
    setData('educations', [...educations, newEducation]);
  };

  const removeEducation = (index: number) => {
    const updatedEducations = educations.filter((_, i) => i !== index);
    setData('educations', updatedEducations);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography variant="h5" component="h2" sx={{ fontWeight: 600 }}>
          Education
        </Typography>
        <Chip label="Optional" color="default" size="small" />
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
        <Button startIcon={<Add />} onClick={addEducation}>
          Add Education
        </Button>
      </Box>

      {educations.map((_, index) => (
        <Box key={index} sx={{ border: 1, borderColor: 'divider', borderRadius: 1, p: 3 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="subtitle1">Education #{index + 1}</Typography>
            <Button startIcon={<Delete />} color="error" onClick={() => removeEducation(index)}>
              Remove
            </Button>
          </Box>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextInput label="School/Institution" name={`educations.${index}.school`} fullWidth required />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextInput label="Degree Level" name={`educations.${index}.level`} fullWidth required />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextInput label="Area of Study" name={`educations.${index}.areaOfStudy`} fullWidth required />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextInput label="Description" name={`educations.${index}.description`} fullWidth multiline rows={3} />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <DateInput label="Start Date" name={`educations.${index}.startDate`} />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <DateInput label="End Date" name={`educations.${index}.endDate`} />
            </Grid>
          </Grid>
        </Box>
      ))}

      {educations.length === 0 && (
        <Alert severity="info">Click "Add Education" to start adding your educational background.</Alert>
      )}
    </Box>
  );
};

export default EducationStep;
